import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=38b3059b"
import script from "./dashboard.vue?vue&type=script&lang=js"
export * from "./dashboard.vue?vue&type=script&lang=js"
import style0 from "./dashboard.vue?vue&type=style&index=0&id=38b3059b&prod&lang=less"
import style1 from "./dashboard.vue?vue&type=style&index=1&id=38b3059b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports